"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.Media = void 0;
const jsx_runtime_1 = require("react/jsx-runtime");
const clsx_1 = require("clsx");
const styles_1 = require("./styles");
const Media = props => {
    const { contentState, blockProps, block } = props;
    const { url, width, height, alignment, type } = contentState.getEntity(block.getEntityAt(0)).getData();
    const { onClick, readOnly, focusKey } = blockProps;
    const classes = (0, styles_1.useStyles)();
    const htmlTag = () => {
        const componentProps = {
            src: url,
            className: (0, clsx_1.clsx)(classes.root, {
                [classes.editable]: !readOnly,
                [classes.focused]: !readOnly && focusKey === block.getKey(),
            }),
            width,
            height: type === "video" ? "auto" : height,
            onClick: () => {
                if (readOnly) {
                    return;
                }
                onClick(block);
            },
        };
        if (!type || type === "image") {
            return (0, jsx_runtime_1.jsx)("img", Object.assign({}, componentProps));
        }
        if (type === "video") {
            return (0, jsx_runtime_1.jsx)("video", Object.assign({}, componentProps, { autoPlay: false, controls: true }));
        }
        return null;
    };
    return ((0, jsx_runtime_1.jsx)("div", { className: (0, clsx_1.clsx)({
            [classes.centered]: alignment === "center",
            [classes.leftAligned]: alignment === "left",
            [classes.rightAligned]: alignment === "right",
        }), children: htmlTag() }));
};
exports.Media = Media;
//# sourceMappingURL=index.js.map